import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextButton } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { routes } from '~/constants';
import { toAgreementListParts } from './ConnectedAgreementLinks.utils';
export const GetConnectedAgreementLinksTID = (parentTestId)=>getTestIds(parentTestId);
export const ConnectedAgreementLinks = (param)=>{
    let { agreements } = param;
    const { ConnectedAgreementLinksTestIds: TID } = useMemo(()=>GetConnectedAgreementLinksTID(), []);
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: toAgreementListParts(agreements, i18n.language).map((part)=>part.type === 'agreement' ? /*#__PURE__*/ _jsx(TextButton, {
                bi: {
                    name: 'client_detail_payment_method_connected_agreement'
                },
                testId: TID.Agreement(part.agreement.relationshipId),
                variant: "paragraph3",
                skin: "primary",
                weight: "light",
                underline: "none",
                onClick: ()=>navigate(routes.agreementMinisiteRoutes(part.agreement.relationshipId).agreement),
                children: part.agreement.title
            }, part.agreement.relationshipId) : /*#__PURE__*/ _jsx(Fragment, {
                children: part.text
            }, part.key))
    });
};
